import { render } from "./DualPdfButton.vue?vue&type=template&id=0ecf867a&scoped=true&ts=true"
import script from "./DualPdfButton.vue?vue&type=script&lang=ts"
export * from "./DualPdfButton.vue?vue&type=script&lang=ts"

import "./DualPdfButton.vue?vue&type=style&index=0&id=0ecf867a&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecf867a"],['__file',"src/components/Buttons/DualPdfButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ecf867a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ecf867a', __exports__)) {
    console.log('reload')
    api.reload('0ecf867a', __exports__)
  }
  
  module.hot.accept("./DualPdfButton.vue?vue&type=template&id=0ecf867a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0ecf867a', render)
  })

}


export default __exports__